import { useEffect, useState } from '@wordpress/element';

export function OptiTable({ colunas, dados, renderizarLinha, mensagemSemDados }) {
  const [itensFiltrados, setItensFiltrados] = useState(dados ?? [])

  return (
    <div className="overflow-auto mt-6">
      <table className="w-full table-auto flex flex-col divide-y divide-fundo-borda-grafico text-left">
        <thead className="pb-5">
          <tr className="flex justify-between w-full bg-neutras-grey-light rounded-lg py-2 px-4">
            {colunas?.map(coluna => (
              <th key={coluna.id} className={`w-${coluna.width}/12`}>
                {coluna.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-fundo-borda-grafico w-full">
          {itensFiltrados.length > 0 ? (
            itensFiltrados.map(item => renderizarLinha(item))
          ) : (
            <tr className="min-h-[15.438em] items-center justify-center flex h-full">
              <td>
                <div>{mensagemSemDados}</div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
